<script setup>
  import { ref, reactive, watch, onMounted, nextTick } from 'vue'
  import utilFunctions from "../../firebase_settings/utils.js"
  import { StripeElements, StripeElement } from 'vue-stripe-js'

  const emit = defineEmits(['executeMethod']);
  //親コンポーネントから受け継いだ支払情報
  const props = defineProps({
        PayObject: {
          type: Object,
          required: true
        },
        cardNumberElement: { 
          type: Object,
          required: true
        },
        cardExpiryElement: { 
          type: Object,
          required: true
        },
        cardCvcElement: { 
          type: Object,
          required: true
        }
    });

  // DOM操作
  const modalTitle = ref(null); //モーダルタイトル
  const cardButtonTrue = ref(null); //OKボタン
  const isDisabled = ref(false); //ボタン非活性化用

  const exitModal = (async (editFlag) => {
    //親コンポーネントに編集の是非とその値を渡す
    emit('executeMethod', editFlag, props.PayObject.Kind, document.getElementById('CardName').value);
    //モーダルウィンドウを閉じる際にボタンを非活性化
    isDisabled.value = true;
  })

  // Stripe Elementsの設定
  const initStripeElements = () => {
  
    //カード名義入力欄の設定
    props.cardNumberElement.mount('#card-number'); //要素をマウント
    //入力値のエラー検知
    props.cardNumberElement.on('change', (event) => {
      document.getElementById('errmsgNumber').textContent = event.error ?
        event.error.message : '';
    });

    //有効期限入力欄の設定
    props.cardExpiryElement.mount('#card-expiry'); //要素をマウント
    //入力値のエラー検知
    props.cardExpiryElement.on('change', (event) => {
      document.getElementById('errmsgExpiry').textContent = event.error ?
        event.error.message : '';
    });

    //セキュリティコード入力欄の設定
    props.cardCvcElement.mount('#card-cvc'); //要素をマウント
    //入力値のエラー検知
    props.cardCvcElement.on('change', (event) => {
      document.getElementById('errmsgCvc').textContent = event.error ?
        event.error.message : '';
    });
  }

  onMounted(async () => {
    if((!props.cardNumberElement) ||
      (!props.cardExpiryElement) || (!props.cardCvcElement)) return;

    //モーダルウィンドウのタイトル/ボタン表示の設定
    if(props.PayObject.Kind == "RegistCard") {
      modalTitle.value.innerHTML = "クレジットカードを登録し、カード払いに変更できます。"
      cardButtonTrue.value.innerHTML = "登録する"
    }
    else if(props.PayObject.Kind == "ChangeCard") {
      modalTitle.value.innerHTML = "クレジットカード情報変更"
      cardButtonTrue.value.innerHTML = "変更する"
    }
    //ボタンの活性化
    isDisabled.value = false

    //Card Elementにカード情報をマウント
    try{
      initStripeElements()
    }catch(error){
      console.error(error)
    }
  })

</script>

<template>
  <div class="modalArea">
    <div id="modalContent" class="modal">
      <p id="editCardmodalTitle" ref="modalTitle">""</p>
      <div>
        <img src="../../assets/Multi Card Checkout Logo.png" id="cardicon">
      </div>
      <table class="cardInfoTable">
        <tbody>
          <tr>
            <th class="cardmodalTh">カード名義</th>
            <td><input class="inputcardInfo" type="text" id="CardName" placeholder="半角英字でご入力ください"/></td>
          </tr>
          <tr>
            <th class="cardmodalTh">カード番号</th>
            <td><div class="inputcardInfo" id="card-number"></div>
              <p class="errmsgCard" id="errmsgNumber"></p>
          </td>
          </tr>
          <tr>
            <th class="cardmodalTh">有効期限</th>
            <td><div class="inputcardInfo" id="card-expiry"></div>
              <p class="errmsgCard" id="errmsgExpiry"></p>
            </td>
          </tr>
          <tr>
            <th class="cardmodalTh">セキュリティコード</th>
            <td><div class="inputcardInfo" id="card-cvc"></div>
              <p class="errmsgCard" id="errmsgCvc"></p>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button id="cardButtonTrue" ref="cardButtonTrue" @click="exitModal(true)" :disabled="isDisabled">登録する</button>
        <span class="buttonBetween"></span>
        <button id="cardButtonFalse" @click="exitModal(false)" :disabled="isDisabled">キャンセル</button>
      </div>
    </div>
    <div class="modalOverlay" @click.self="exitModal(false)"></div>
  </div>
</template>

<style scoped>
  .modal {
    width: 600px;
    height: auto;
    top: 50%;
    left: 50%;
  }
  #editCardmodalTitle {
    font-size: 24px;
    font-weight: bold;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .buttonBetween {
    padding: 0 5% 0 5%;
  }
  #cardButtonTrue {
    width: 150px;
    height: 60px;
    border-radius: 10px;
    border: solid 3px #00AEEB;
    background-color: #00AEEB;
    color: #FFFFFF;
  }
  #cardButtonFalse {
    width: 150px;
    height: 60px;
    border-radius: 10px;
    border: solid 3px #eb8f8f;
    background: #eb8f8f;
    color: #FFFFFF;
  }
  .cardInfoTable{
    margin: 0 0 40px 0;
  }
  .cardInfoTable input{
    padding-left: 0;
  }
  .cardInfoTable input:focus {
    outline: none;
  }
  .cardmodalTh{
    text-align: left;
    font-size: 15px;
  }
  .inputcardInfo{
    border-radius: 8px;
    background-color: #ccc;
    padding: 8px;
    margin: 5px;
    font-size: 11pt;
    border: none;
    height: 16pt;
    width:90%
  }
  #CardName{
    width: 360px;
    margin-right: 5%;
    color:#3f3f3f;
  }
  .errmsgCard{
    color: red;
    text-align: left;
  }
  #cardicon{
    width:50%;
  }

</style>

